import { render, staticRenderFns } from "./syncCollaborate.vue?vue&type=template&id=50675dad&scoped=true"
import script from "./syncCollaborate.vue?vue&type=script&lang=js"
export * from "./syncCollaborate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50675dad",
  null
  
)

export default component.exports